/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 $(document).ready(function() {
 	
 	// ==== Footer Newsletter =====

 	var $newsletterForm = $('form.Subscribe.Form');
 	if($newsletterForm.length > 0){
 		$newsletterForm.validate( {
		  rules: {
		    "contact[email]": {
		      required: true,
		      email: true
		    },
		    agree: "required"
		  },
		  messages: {
		    "contact[email]": {
		      required: "This is a required field",
		      email:"Please enter a valid email address", 
		    },
		    agree: "Please review the privacy policy."
		  },
		  errorElement: "p",
		  errorPlacement: function ( error, element ) {
		  	if(error[0].id == 'agree-error'){
		  		var target_elem = $(element).parent().find('span');
		  		error.insertAfter( target_elem );
		  	} else {
	  			error.insertAfter( element );
		  	}
		    
		  },
		  highlight: function(element) {
		    // $(element).addClass('has-error');
		  },
		  unhighlight: function(element) {
		    // $(element).removeClass('has-error');
		  },
		  submitHandler: function(form, event) {
		  	event.preventDefault();
		  	
		    var formMethord = $(form).attr("method");
		    var formUrl = $(form).attr("action");
		    var formId = formUrl.split('#')[1];
		    jQuery.ajax({
		      type: formMethord,
		      async: true,
		      url: formUrl,
		      data: $(form).serialize(),
		      beforeSend: function() {
		      	$(form).find(".ftr-nl-w").addClass('Image--lazyLoading');
		      },
		      error: function(response, data) {
		      	
		      	$(form).find(".ftr-nl-w").removeClass('Image--lazyLoading');
		      	if ($(form).find("p.Alert--error")) {
		      		$(form).find("p.Alert--error").remove();
		      	}
		        if(response.status == 429) {
		        	$(form).find(".ftr-nl-w").before("<p class='Form__Alert Alert Alert--error'>Please try after some time</p>");
		            // var challengeUrl = window.location.origin +'/challenge#'+ formId
            		// window.location = challengeUrl
		        }else {
		        	$(form).find(".ftr-nl-w").before("<p class='Form__Alert Alert Alert--error'>"+response.responseText+"</p>");
		        }
		      },
		      success: function(data) {
		      	var redirectURL = $(data).filter('link[rel="canonical"]');
		      	var challaengeURL = redirectURL[0].href;
		      	if(challaengeURL.indexOf('/challenge') > -1){
	      			window.location = challaengeURL;
		      	} 
		      	else {
					$(form).find(".ftr-nl-w").removeClass('Image--lazyLoading');
					// console.log('success: ',data);
					var success_msg = $(data).find(".footer_subscribe form.Subscribe");
					success_msg = success_msg.find("p.Alert--success");

					if ($(form).find("p.Alert--error")) {
					  $(form).find("p.Alert--error").remove();
					}

					if(success_msg.length){
						$(form).find(".ftr-nl-w").replaceWith(success_msg);
					} else {
						$(form).find(".ftr-nl-w").replaceWith("<p class='Form__Alert Alert Alert--success'>We just sent you an email to confirm your subscription. To finish signing up, please click the confirmation link in the email.</p>");
					}
		      	}
		      }
		    }); 
		    // form.submit();
		  }
		});
 	}

 	// Footer Mobile dropdown menu
 	
	$('.content_footer_Button').on('click', function(e){
	  e.preventDefault();
	  var scrollPosition = $(window).height() + $(window).scrollTop();
	  if($(this).hasClass('active')){
	    $(this).closest('.Drawer__Container').removeClass('show-content');
	    $(this).next().slideUp();
	  }
	  else {
	    // close opened tabs
	    $('.content_footer_Button').removeClass('active');
	    $('.Footer__Block .Drawer__Container').removeClass('show-content');
	    $('.content_Footer_Inner').slideUp();
	    // show content of clicked tab
	    $(this).next().slideDown();
	    $(this).closest('.Drawer__Container').addClass('show-content');
	    if($(this).hasClass('footer-no-scroll')) {
	      $('html, body').animate({scrollTop: scrollPosition + $(this).height() }, '400');
	    }
	  }
	  $(this).toggleClass('active');
	});

 	// ==== Login page =====

	if ($("#customer_login").length > 0){
		$(".Login__Form").validate( {
		  rules: {
		    "customer[email]": {
		      required: true,
		      email: true
		    },
		    "customer[password]": {
		      required: true,
		      pwcheck:false,
		      minlength: 8,
		      maxlength:20
		    },
		  },
		  messages: {
		    "customer[email]": {
		      required: "This is a required field",
		      email:"Please enter a valid email address (ex: jhondoq@domain.com.)", 
		    },
		    "customer[password]":"This is a required field"
		  },
		  errorElement: "span",
		  errorPlacement: function ( error, element ) {
		    error.addClass( "help-block" );

		    if ( element.prop( "type" ) === "checkbox" ) {
		      error.insertAfter( element.parent( "label" ) );
		    } else {
		      error.insertAfter( element );
		    }
		  },
		  highlight: function(element) {
		    $(element).addClass('has-error');
		  },
		  unhighlight: function(element) {
		    $(element).removeClass('has-error');
		  },
		});
	}

	// ======== Account dashboard =========

	if($('#change_password')[0]){
	  $('#change_password').click(function(){
	    localStorage.setItem("change_password", true);
	    window.location = '/account/login';
	  });
	}
	if($('#customer_login')[0]){
	  var storage_val = localStorage.getItem("change_password");
	  localStorage.removeItem("change_password");
	  if(storage_val != null){
	  	$('#customer_login button[data-action="toggle-recover-form"]')[0].click();
	  }
	}

	// ======== Product page =========
/*
	if($('.Product__SlideshowNav--thumbnails').length > 0) {
		$(".Product__SlideshowNavScroller a").click(function() {
			var position = $(this).position();
			var width = $(this).width();
			$(".Product__SlideshowNavScroller .fotorama__thumb-border").css({"left":+ position.left});
			//  var ele = $('.Product__SlideshowNav').width();
			//  var ele_width = ele - 200;
			//  var thumbnial_width = $('.Product__SlideshowNavScroller').width();
			//  if(ele < thumbnial_width) {
		  	// var left_attr = $(".Product__SlideshowNavScroller .fotorama__thumb-border").attr("style");
				// var array = left_attr.split(';');
				// var l = array[0].split(':');
				// var s = parseInt(l[1]);
				// console.log(ele_width+'--'+s);
				// if (ele_width < s) {
				// 	console.log('bhjb');
			 //  		$(".Product__SlideshowNavScroller").css({"left": -width, "transition-duration": "600ms"});
			 //  	}
			 //  }
		});
		var actWidth = $(".Product__SlideshowNavScroller").find(".is-selected").width();
		var actPosition = $(".Product__SlideshowNavScroller .is-selected").position();
		$(".Product__SlideshowNavScroller .fotorama__thumb-border").css({"left":+ actPosition.left, "transition-duration": "600ms"});

		const slider = document.querySelector(".Product__SlideshowNav");
		let isDown = false;
		let startX;
		let scrollLeft;

		slider.addEventListener("mousedown", function(e){ 
		  isDown = true;
		  slider.classList.add("active");
		  startX = e.pageX - slider.offsetLeft;
		  scrollLeft = slider.scrollLeft;
		});
		slider.addEventListener("mouseleave", function(){ 
		  isDown = false;
		  slider.classList.remove("active");
		});
		slider.addEventListener("mouseup", function(){ 
		  isDown = false;
		  slider.classList.remove("active");
		});
		slider.addEventListener("mousemove", function(e){ 
		  if (!isDown) return;
		  e.preventDefault();
		  const x = e.pageX - slider.offsetLeft;
		  const walk = x - startX;
		  slider.scrollLeft = scrollLeft - walk;
		});
 	}
*/
 	// ==== Contact page =====

	if ($(".ContactUs__Page #contact_form").length > 0){
		$(".ContactUs__Page .Contact__Form").validate( {
		  rules: {
		    "contact[email]": {
		      required: true,
		      email: true
		    },
		    "contact[name]":{
		       required: true
		    },
		    "contact[Phone]":{
		       required: true
		    },
		    "contact[body]":{
		       required: true
		    }
		  },
		  messages: {
		    "contact[email]": {
		      required: "This is a required field",
		      email:"Please enter a valid email address (ex: jhondoq@domain.com.)", 
		    },
		    "contact[name]":"This is a required field",
		    "contact[Phone]":"This is a required field",
		    "contact[body]":"This is a required field",
		  },
		  errorElement: "span",
		  errorPlacement: function ( error, element ) {
		    error.addClass( "help-block" );

		    if ( element.prop( "type" ) === "checkbox" ) {
		      error.insertAfter( element.parent( "label" ) );
		    } else {
		      error.insertAfter( element );
		    }
		  },
		  highlight: function(element) {
		    $(element).addClass('has-error');
		  },
		  unhighlight: function(element) {
		    $(element).removeClass('has-error');
		  },
		});
	}

	// ==== Custom Wishlist page =====
	if($('section[data-section-type="wishlist-page"]').length) {
		//This jQuery based code fetches the contents of Express Wishlist (unregistered users)
		// var wishlistid = SWGetExpressWishlistId();    
		// $.ajax({
		// 	url: "/a/wishlist?type=api&wishlistid="+wishlistid+"&version=1",
		// 	dataType: "json",
		// 	cache:false,
		// 	success: function(data) {
		// 		console.log(data);
		// 	}
		// });

		//the above code adapted for customer wishlist (logged in users)
		// var customerid = SWGetCustomerWishlistId();
		// $.ajax({
		// 	url: "/a/wishlist?type=api&customerid="+customerid+"&version=1",
		// 	dataType: "json",
		// 	cache:false,
		// 	success: function(data) {
		// 		console.log(data);
		// 	}
		// });
	}
	
   // Skip Shipping Destination screen if you're from the UK store
   	  var redirect_to_asia_oci = "https://asia.gievesandhawkes.com/",
        redirect_to_china = "https://gieveshawkes.world.tmall.com/";
      var come_from = 'asia.gievesandhawkes.com'
	
	  var initreferrer = document.referrer;
	  if(initreferrer.indexOf(come_from) != -1 ) { 
	    $("#shiping_detection_overlay").css("display","none");
        setCookie('referrer',initreferrer,1); // set cookie to not show the shipping destination screen on all pages
	  }
	  
	  var referrer = readCookie('referrer');
	  // if referrer cookie is set, then do not display the shipping destination screen
	  if (referrer) {
	    if(referrer.indexOf(come_from) != -1 ) { 
          $("#shiping_detection_overlay").css("display","none");
	    }
	  }

	// ==== Shipping destination and IP auto redirect =====

	// ==== dropdown box value changes =====

	function changeBtnVal(){
		var val = $('#ship_countries').attr("value");
		var lists = $('.dropdown_box li.continent_item');
		lists.each(function(i){
			var value_li = $(this).find('a').attr('value');
			if (val == value_li) {
				$(this).css("display","none");
			} else {
				$(this).css("display","block");
			}
		});
	}

	$("button#ship_countries").click(function(){
	  $("ul.dropdown_box").toggle();
	  $(".cuntry_selecotor span").toggleClass("arr_rot");
	})

	$("#section-header a.ship_to_btn").click(function(){
	  let ship_drop_header = $(this).parent(".header_ship-to").find(".content_dropdown_box");
	  ship_drop_header.toggle();
	  $(this).find("span").toggleClass("arr_rot");
	});

    //  ==== hide dropdown box on click out of box
	$(document).click(function(e){
		if (($(e.target).closest(".content_dropdown_box").length === 0) && ($(e.target).closest(".header_ship-to").length === 0))  {
			if($(".content_dropdown_box").css('display') == 'block') {
				$(".content_dropdown_box").css('display','none');
				var dropdown_hasClass = $("#section-header a.ship_to_btn span").hasClass("arr_rot");
				if (dropdown_hasClass === true) {
					$("#section-header a.ship_to_btn span").removeClass("arr_rot");
				}
			}
		}
	});


	// set dropbox value on select option
	$("ul.dropdown_box li.continent_item").click(function(){
	  var attr_val = $(this).find("a").attr("value");

	  let drop_box = $("button#ship_countries"); 
	  let drop_box_cont = $("button#ship_countries p");

	  drop_box.attr("value", attr_val);
	  drop_box_cont.text($(this).find("a").text());

	  $("ul.dropdown_box").hide();
	  $(".cuntry_selecotor span").removeClass("arr_rot");

	  // change dropdown contents;
	  changeBtnVal();
	});


    //  Redirect value on cehck cookies and send to given url
	function redirect_location(link_url, check_domin_1, check_domin_2) {
	  let url_domain = check_domin_1;
	  let url_domain_2 = check_domin_2;

	  window_url = window.location.href;
	  let search_url_domain = window_url.search(url_domain);
	  let search_url_domain_2 = window_url.search(url_domain_2);
	    // console.log(search_url_domain)
	      // console.log(search_url_domain_2)
	  if(search_url_domain > 0 || search_url_domain_2 > 0 ){
	  } else {
	    window.location.href = link_url;
	  }
	}

    // seting dropbox value by checking diffrent conditions
	function check_case(case_value){
	  // dropdown content
	  let drop_box = $("button#ship_countries");
	  let drop_box_cont = $("button#ship_countries p");
	  switch (case_value) {
	    case 'Europe': 
	      drop_box.attr("value", case_value)
	      drop_box_cont.text("United Kingdom")
	      break;
	    case 'Asia': 
	      drop_box.attr("value", case_value)
	      drop_box_cont.text("Asia Pacific")
	      break;
	    case 'Oceania': 
	      drop_box.attr("value", case_value)
	      drop_box_cont.text("Oceania")
	      break;
	    case 'China': 
	      drop_box.attr("value", case_value)
	      drop_box_cont.text("China")
	      break;
	    default:
	      drop_box.attr("value", "rest-of-world")
	      drop_box_cont.text("Rest Of World")
	  }
	  //  overlay key change
      let list_country = $(".shipping_country_list li.box_item");
      $(list_country).each(function(item){
        var attr_val = $(this).find("a").attr("value");
        if(attr_val === case_value) {
          $(this).find("a").addClass("selected");
        } else {
          $(this).find("a").removeClass("selected");
        }
      })
	}

	function readCookie(name) {
	  var nameEQ = name + "=";
	  var ca = document.cookie.split(';');
	  for(var i=0;i < ca.length;i++) {
	    var c = ca[i];
	    while (c.charAt(0)==' ') c = c.substring(1,c.length);
	    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	  }
	  return null;
	};

	function deleteCookie(name) {
	  setCookie(name,"",-1);
	}
	function setCookie(name,value,days) {
	  if (days) {
	    var date = new Date();
	    date.setTime(date.getTime()+(days*24*60*60*1000));
	    var expires = "; expires="+date.toGMTString();
	  }
	  else expires = "";
	  document.cookie = name+"="+value+';'+expires+"; path=/";
	}

    // content redirect after select value from dropdown and list
	function clickRedirect(ship_value) {
      setCookie('shiping_location',ship_value, 3)

	    let current_url = window.location.href;
	    let pages_avail = current_url.search("shipping-destination");
	    if(pages_avail > 0) {
          if(ship_value == "Europe" || ship_value == "rest-of-world") {
              let redir_url = window.location.href.split("pages")[0];
		      window.location.href = redir_url;
          } else if(ship_value == "China"){
	        deleteCookie('shiping_location');
	        window.location.href = redirect_to_china;
          } else {
	        deleteCookie('shiping_location');
	        window.location.href = redirect_to_asia_oci;
          }
	    } else {
	      if(ship_value == "Europe" || ship_value == "rest-of-world") {
	       $("#shiping_detection_overlay").css("display","none");
           if($("html.js").hasClass("no-scroll")){
              $("html.js").removeClass("no-scroll");
            }
            check_case(ship_value);
            changeBtnVal();
	       // $("main#main").removeClass("hide_block_mobile");
	      } else if(ship_value == "China"){
	        deleteCookie('shiping_location');
	        window.location.href = redirect_to_china;
          } else {
	        deleteCookie('shiping_location');
	        window.location.href = redirect_to_asia_oci;
	      }
	    }
    }

    // get value and redirect from dropdown continue
	$("button.close_continue").click(function(){
	  let value_shipping = document.getElementById("ship_countries").getAttribute("value");
	  	clickRedirect(value_shipping)

	    let header_ship = $(this).parents(".header_ship-to");
	    header_ship.find(".content_dropdown_box").css("display","none");
	    header_ship.find(".ship_to_btn span").removeClass("arr_rot");

	})

    // get value and redirect from overlay list
	$("#shiping_detection_overlay .shipping_country_list .box_item a").click(function(){
      let value_shipping = this.getAttribute("value");
      clickRedirect(value_shipping)
    })

    // Check from cookie if not set? then go to esle
	var isShipingLocation = readCookie('shiping_location');
	if (isShipingLocation) {
	  $("#shiping_detection_overlay").css("display","none");
	  if($("html.js").hasClass("no-scroll")){
        $("html.js").removeClass("no-scroll");
      }
	  check_case(isShipingLocation);
	  let redirect_value;
	  switch (isShipingLocation) {
	    case 'Europe': 
	        // redirect_value = "https://gievesandhawkes-01.myshopify.com/";
	        // redirect_location(redirect_value, 'gievesandhawkes-01', 'gievesandhawkes');
	      break;
	    case 'Asia': 
	        // Temp delete
	        deleteCookie('shiping_location');
	        // ______________________
	        redirect_value = redirect_to_asia_oci;
	        redirect_location(redirect_value, 'asia.gievesandhawkes', 'asia.gievesandhawkes');
	      break;
	    case 'Oceania': 
	        // Temp delete
	        deleteCookie('shiping_location');
	        // ______________________
	        redirect_value = redirect_to_asia_oci;
	        redirect_location(redirect_value, 'asia.gievesandhawkes', 'asia.gievesandhawkes');
	      break;
	     case 'China': 
// 	        Temp delete
	        deleteCookie('shiping_location');
	        // ______________________
	        redirect_value = redirect_to_china;
	        redirect_location(redirect_value, 'gieveshawkes.world.tmall', 'gieveshawkes.world.tmall');
	      break;
	    default:
	        // redirect_value = "https://gievesandhawkes-01.myshopify.com/";
	        // redirect_location(redirect_value, 'gievesandhawkes-01', 'gievesandhawkes');
	  }
	  changeBtnVal();
	} else {
	  // change dropdown contents;

	  $.get("https://pro.ip-api.com/json/?key=NXG9W9I1xxwJGvN", function (response) {

	    let redirect_country = response.countryCode;
	    
	    const continents = [{ continent: 'Europe', countries_code: ['GB', 'GG', 'JE', 'IM'] }, { continent: 'China', countries_code: ['CN'] }, { continent: 'Asia', countries_code: ['AF', 'AZ', 'BH', 'BD', 'AM' , 'BT', 'IO' , 'BN', 'MM', 'KH', 'LK', 'TW', 'CX', 'CC', 'CY', 'GE', 'PS', 'HK', 'IN', 'ID', 'IR', 'IQ', 'IL', 'JP', 'KZ', 'JO', 'KP', 'KR', 'KW', 'KG', 'LA', 'LB', 'MO', 'MY', 'MV', 'MN', 'OM', 'NP', 'PK', 'PH', 'TL', 'QA', 'RU', 'SA', 'SG', 'VN', 'SY', 'TJ', 'TH', 'AE', 'TR', 'TM', 'UZ', 'YE', 'XD', 'XE', 'XS'] }, { continent: 'Oceania', countries_code: ['XX', 'WF', 'WS', 'TV', 'TO', 'TK', 'PN', 'PG', 'PW', 'MH', 'FM', 'UM', 'MP', 'NF', 'NU', 'NZ', 'VU', 'NC', 'NR', 'KL', 'GU', 'PF', 'FJ', 'CK', 'SB', 'AU', 'AS'] }],
	    countries_new = [redirect_country], lookup = {};
	    
	    for(let i=0; i < continents.length; i++) {
	      let obj = continents[i];
	      for(let j=0; j < obj.countries_code.length; j++){
	        let country = obj.countries_code[j];
	        lookup[country] = obj.continent;
	      }
	    }

	    let result = {};
	    for(let n=0; n<countries_new.length; n++) {
	      let new_result = countries_new[n];
	      result.continent = lookup[new_result];
	    }

	    let continent_redirect = result.continent;
	    check_case(continent_redirect);
	    let index_value
	    switch (continent_redirect) {
	      case 'Europe': 
	          $("#shiping_detection_overlay").css("display","none");
	 		  changeBtnVal();
	        break;
	        case 'Oceania': 
	          $("html.js").addClass("no-scroll");
              $("#shiping_detection_overlay").css("display","flex");
   	  		  changeBtnVal();
	        break;
	        case 'Asia': 
	           $("html.js").addClass("no-scroll");
            $("#shiping_detection_overlay").css("display","flex");
              changeBtnVal();
	        break;
            case 'China': 
              $("html.js").addClass("no-scroll");
            $("#shiping_detection_overlay").css("display","flex");
              changeBtnVal();
	        break;
	      default:
	          $("#shiping_detection_overlay").css("display","none");
              changeBtnVal();
	    }

	    if (referrer) {
		    if(referrer.indexOf(come_from) != -1 ) { 
	        if($("html.js").hasClass("no-scroll")){
	            $("html.js").removeClass("no-scroll");
                $("#shiping_detection_overlay").css("display","none");
	          }
		    }
		  }
	  });
	}
});

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    var headerHeight = $("#shopify-section-header").height();
    var ancBarHeight = $("#shopify-section-announcement").height();
    let total_height = ancBarHeight;
    if(scroll >= total_height) {
        $("#shiping_detection_overlay").addClass("change_scroll");
    } else {
        $("#shiping_detection_overlay").removeClass("change_scroll");
    }
});
